module.exports = __webpack_public_path__ + "img/inseeexpress-laodl-800x800.3083f96b.jpg";